type Props = {
    children: any
}

const ModalHeader = (props: Props) => {
    return (
        <div className="modal-header">
            {props.children}
        </div>
    );
};

export default ModalHeader;
